// The walkthrough of the phone app's My training page (docs/clairvoyance/18-help-and-training.md).
import type { Walkthrough } from '@ecobox/domain';

export const OPS_TRAINING_WALKTHROUGH: Walkthrough = {
  id: 'ops-training',
  app: 'ops',
  pageTitle: 'My training',
  summary: 'The walkthroughs of the screens you use on the phone, and which ones you have taken.',
  version: 1,
  steps: [
    {
      title: 'What this page is for',
      body: 'Every screen you use on the phone has a short walkthrough. This list shows them, and which ones you have taken.',
    },
    {
      target: 'training-progress',
      title: 'How far you are',
      body: 'How many you have done out of how many you have. A screen that changed since you took it is not counted as done.',
    },
    {
      target: 'training-list',
      title: 'Take a walkthrough',
      body: 'Each row says New, Done, Changed or Skipped. Press Take it to open the screen and start its walkthrough.',
    },
    {
      title: 'Help on every screen',
      body: 'The Help button at the top of every screen has the walkthrough, a demo that plays by itself, and this list.',
    },
  ],
};
